import { render } from "./DocumentPlusIcon.vue?vue&type=template&id=0e35d76a"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__